import '../../../css/bem/_quick-wishlist.scss';
import panelUpdater from '@remarkablenet/panel-updater';

import { getQuickwishlistHTML, removeFromWishlist, getWishlistCount } from '../wishlist/wishlist-services';
import { updateWishlistCount, toggleIconState } from '../wishlist/wishlist-ui';
import * as CSSTH from '../css-transition-helper/css-transition-helper';
import { disableScroll, enableScroll } from '../utility-functions/utility-functions';
import { showSolidHeader, showGlassHeader } from '../../global';
import { addClass, addDelegateEventListener, removeClass, isTouch } from '@remarkablenet/rcm-utils';

const DEFAULTS = {
    quickWishlist: '.quick-wishlist',
    quickWishlistContent: '.quick-wishlist__content',
    quickWishlistCount: '.quick-wishlist__count'
};

const modifyContent = (elm, html) => { elm.innerHTML = html; };

const loadQuickWishlist = (elm:HTMLElement, timeout:null | number = null) => {
    const panel = elm.querySelector('.panel-updater');
    if (timeout) elm.onmouseenter = () => clearTimeout(timeout);
    if (elm.classList.contains('is-active')) {
        updateQuickWishlist(panel);
        return;
    }

    // Match scroll / header behaviour with other header overlays
    if (!isTouch()) {
        showSolidHeader();
        disableScroll();
    } else {
        if (document.body.classList.contains('header-is-revealed')) disableScroll();
    }

    CSSTH.activate(elm);
    updateQuickWishlist(panel);
    const html = document.querySelector('html');
    if (html) addClass({ elm: html, className: ['quick-wishlist-active'] });
    setupCloseQuickWishlist(elm);
};

const updateQuickWishlist = async (elm) => {
    const html = await panelUpdater(elm, getQuickwishlistHTML());
    modifyContent(elm, html);
    setupQuickWishlistDelete(elm);
    setupCloseQuickWishlist(elm);
};

export const refreshQuickWishlistPanel = () => {
    const content = document.querySelector<HTMLElement>('.quick-wishlist__content');
    if (!content?.classList.contains('is-active')) return;
    const panel = content.querySelector<HTMLElement>('.panel-updater');
    if (panel) void updateQuickWishlist(panel);
};

const setupQuickWishlistDelete = elm => {
    elm.querySelectorAll('.js-quick-wishlist-item-remove')
        .forEach(item => {
            const shoppingBasketId = Number(item.dataset.pid);

            item.addEventListener('click', e => {
                e.preventDefault();
                quickwishlistDelete(shoppingBasketId, elm, item);
            });
        });
};

const setupCloseQuickWishlist = elm => {
    elm.querySelectorAll('.js-close-quick-wishlist')
        .forEach(item => {
            item.addEventListener('click', e => {
                CSSTH.deactivate(elm);
                document.querySelectorAll('.quick-wishlist__content').forEach(e=>e.classList.remove('is-active'));
                document.querySelectorAll('.quick-wishlist__content').forEach(e=>e.classList.remove('is-visible'));
                const html = document.querySelector('html');
                if (html) removeClass({ elm: html, className: ['quick-wishlist-active'] });
                enableScroll();
                showGlassHeader(500);
            });
        });
};

const quickwishlistDelete = (id, elm, item) => {
    removeFromWishlist(id)
        .then(async (r) => {
            if (r.success) {
                var reset = false,
                    parent = item.closest('.quick-wishlist-item'),
                    count = await getWishlistCount({cacheBuster: true});
                parent.classList.add('quick-wishlist-item--fade');
                toggleIconState(id);
                updateWishlistCount(count);

                parent.addEventListener('transitionend', () => {
                    if (!reset) {
                        reset = true;
                        if (!count)
                            updateQuickWishlist(elm);
                        else
                            parent.remove();
                    }
                });
            }
        });
};

// preview quickwishlist
export const previewQuickwishlist = (
    quickWishlistContent = DEFAULTS.quickWishlistContent,
    quickWishlist = DEFAULTS.quickWishlist
) => {
    const QUICK_WISHLIST = document.querySelector(quickWishlist);
    const QUICK_WISHLIST_ELEMENT = QUICK_WISHLIST.querySelector(quickWishlistContent);
};


// quick wishlist init
export const init = (quickWishlist = DEFAULTS.quickWishlist, quickWishlistContent = DEFAULTS.quickWishlistContent) => {
    const QUICK_WISHLIST = document.querySelector<HTMLElement>(quickWishlist);
    const QUICK_WISHLIST_ELEMENT = QUICK_WISHLIST.querySelector<HTMLElement>(quickWishlistContent);

    QUICK_WISHLIST.querySelector("a").addEventListener('click', async (e) => {
        e.preventDefault();
        if (QUICK_WISHLIST_ELEMENT.classList.contains('is-active')) return;
        loadQuickWishlist(QUICK_WISHLIST_ELEMENT);
    });

    addDelegateEventListener({ container: document, event: 'click', target: '.js-open-quick-wishlist', callback: async (e) => {
        e.originalEvent.preventDefault();
        if (QUICK_WISHLIST_ELEMENT.classList.contains('is-active')) return;
        loadQuickWishlist(QUICK_WISHLIST_ELEMENT);
    } });

    return {
        loadQuickWishlist: () => loadQuickWishlist.bind(null, QUICK_WISHLIST_ELEMENT)()
    };
};
